import classNames from 'classnames';

import { Heading3 } from '../Text';
import { TextProps } from '../Text/TextBase';

import style from './list-item-heading.module.css';

interface ListItemHeadingProps {
  children: string;
  className?: string;
  fontColor?: Extract<TextProps['fontColor'], 'black' | 'turquoise'>;
}

const ListItemHeading = ({
  children,
  className,
  fontColor,
}: ListItemHeadingProps) => {
  return (
    <Heading3
      className={classNames(style.listItemHeading, className)}
      fontColor={fontColor ?? 'turquoise'}
    >
      {children}
    </Heading3>
  );
};

export default ListItemHeading;
